import {
	checkHasApprovalHierarchy,
	getCurrency,
	getEntityById,
	getImageCountErrorRules,
	getObjectValues,
	getWarrantyStatus,
	isInternalTeam,
	isSupplierPayingCustomerAndAdmin,
	isValidNumber,
	nullSafeGet,
	nullSafeGetOrElse,
	nullSafeToFixed,
} from '../../utils/DataAccessUtils';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
	Input,
	Select,
	Button,
	Modal,
	InputNumber,
	message,
	DatePicker,
	Row,
	Spin,
	Radio,
	Popover,
} from 'antd';
import { imageUploadValidation, normFile } from '../../utils/ImageUtils';
import BackButton from '../back_button/BackButton';
import * as React from 'react';
import _ from 'lodash';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import ProblemTypeTreeSelect from '../problem_type_tree_select';

import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { assetsRestCrudThunksForSupplier } from '../../thunks/assets_thunks';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import {
	problemTypesRestCrudThunksForSupplier,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import { workOrderAttributesRestCrudThunksForSupplier } from '../../thunks/work_order_attributes_thunks';
import {
	workOrderPrioritiesRestCrudThunksForSupplier,
	workOrderPrioritiesWithoutPMRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
import {
	approveWorkOrderForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import {
	addWarrantySupplierToStoreState,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import {
	PRE_SUPPLIER_ASSIGNMENT_STATUSES,
	WORK_ORDER_STATUSES,
} from '../../constants/WorkOrderStatuses';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import {
	areasRestCrudThunksForBuyer,
	areasRestCrudThunksForSupplier,
	fetchAreasWithHeirarchy,
} from '../../thunks/areas_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import SupplierSelectionWorkOrderSelect from '../supplier_selection_work_order_select';
import {
	getBuyerCompanyApprovalTiers,
	getProposalApprovalHierarchiesByAttributes,
	hasApprovalHierarchyChanged,
} from '../../thunks/company_approval_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { SUPPLIER_ADMIN_ONLY } from '../roles/roles';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { projectsRestCrudThunksForSupplier } from '../../thunks/projects_thunks';
import { resolutionTypesRestCrudThunksForSupplier } from '../../thunks/resolution_types_thunks';
import ApprovalHierarchyChangeModal from '../ApprovalHierarchyChangeModal';
import {
	getBuyerCompanySettingValue,
	isUserAllowedToAccess,
	PERMISSION_NAMES,
} from '../../utils/AuthUtils';
import OWRichTextEditor from '../../rich_text_editor/OWRichTextEditor';
import { proposalsRestCrudThunksForSupplier } from '../../thunks/proposals_thunks';
import {
	getDueDate,
	getNewLocationNTE,
	isManagedBuyerCompanyIdWO,
} from '../../utils/WorkOrderUtils';
import OWUpload from '../OWUpload';
import { isInApprovalHierarchy } from '../../utils/ApprovalHierarchyUtils';
import { defensiveIsUserInternalSupplier } from '../../constants/defensive';
import AssetWorkOrderSelect from '../asset_work_order_select/AssetWorkOrderSelect';
import { NTE_LOCKED_STATUSES } from '../../constants/InvoiceStatuses';
import { invoicesRestCrudThunksForSupplier } from '../../thunks/invoices_thunks';
import WorkOrderIsPrivateFormItem from '../work_order_is_private_form_item/WorkOrderIsPrivateFormItem';
import { addSupplierSubscribersForSuppliers } from '../../thunks/work_orders_subscribers_thunks';
import { WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS } from '../../actions/work_order_priorities_actions';
import moment from 'moment';
import WOIsWarrantyFormField from '../work_order_edit_form/WOIsWarrantyFormField';
import { InfoCircleOutlined } from '@ant-design/icons';
import CapExCategoryFormField from '../work_order_edit_form/CapExCategoryFormField';
import {
	capexAssociationRestCrudThunksForSupplier,
	deleteCapexCategoryAssociation,
} from '../../thunks/capex_association_thunks';
import TransferWorkOrder from '../transfer_work_order/TransferWorkOrder';

const WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE = 'SUPPLIER_WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE';
const WORK_ORDER_FORM_AREAS_AUTOCOMPLETE = 'SUPPLIER_WORK_ORDER_FORM_AREAS_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE =
	'SUPPLIER_WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE';
const WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE =
	'SUPPLIER_WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE';
const WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE =
	'SUPPLIER_WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE';
const WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE = 'WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE';

interface WorkOrderFormProps extends FormComponentProps {
	history: any;
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	creating: boolean;
	updating: boolean;
	formData: any;
	createErrors: any[];
	updateErrors: any[];
	fetchMultipleLocations: any;
	fetchLocations: any;
	fetchLocation: any;
	locations: any;
	fetchAsset: any;
	fetchMultipleAssets: any;
	fetchAssets: any;
	assets: any;
	fetchMultipleAreas: any;
	fetchAreas: any;
	areas: any;
	fetchMultipleProblemTypes: any;
	fetchProblemTypes: any;
	fetchProblemType: any;
	getQuotes: any;
	problemTypes: any;
	fetchMultipleSpendCategories: any;
	fetchSpendCategories: any;
	spendCategories: any;
	fetchWorkOrderAttributes: any;
	fetchWorkOrderPriority: any;
	fetchMultipleWorkOrderPriorities: any;
	fetchWorkOrderPriorities: any;
	workOrderPriorities: any;
	supplierFacilities: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetworkInternal: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	currentUser: any;
	updateWorkOrderForm: any;
	fetchSupplierFacility: any;
	fetchSupplierCompany: any;
	fetchApprovalHeirarchy: any;
	addWarrantySupplier: any;
	fetchExchangeRate: any;
	projects: any;
	fetchProjects: any;
	fetchMultipleProjects: any;
	resolutionTypes: any;
	fetchMultipleResolutionTypes: any;
	fetchResolutionTypes: any;
	approveWorkOrderForm: any;
	isApprovalForm: any;
	willApprovalHierarchyChange: any;
	companyConfig: any;
	addSupplierSubscribers: any;
	getInvoiceCounts: any;
	getApprovalHierarchy: any;
	updateWOPriorityRecords: any;
	saveCapExAssociation: any;
	deleteCapExAssociation: any;
}

class SupplierWorkOrderEditForm extends React.Component<WorkOrderFormProps, any> {
	confirmChange: any = () => {};
	cancelChange: any = () => {};

	constructor(props) {
		super(props);
		this.state = {
			workOrderApprovalHierarchy: nullSafeGet('formData.approvalHierarchy', props),
			hasApprovalHierarchy: nullSafeGet('formData.hasApprovalHierarchy', props),
			woChanges: {},
			woPriorityId: nullSafeGet('formData.woPriorityId', props),
			problemTypeId: nullSafeGet('formData.problemTypeId', props),
			locationId: nullSafeGet('formData.locationId', props),
			userApprovalInfo: {},
			previewVisible: false,
			uploadLoading: false,
			previewImage: false,
			inputValues: {},
			nteAmount: 0,
			workOrderPriority: null,
			workOrderPriorityId: null,
			buyerFacilityId: null,
			assetSelectionDisabled: true,
			allPhotos: [],
			approvalHeirarchy: {},
			buttonLoading: false,
			isCapex: nullSafeGetOrElse('formData.isCapex', props, false),
			asset: nullSafeGet('formData.asset', props),
			warranty: nullSafeGet('formData.asset.warranties.0', props),
			supplierFacilityId: nullSafeGet('formData.supplierFacilityId', props),
			supplier: nullSafeGetOrElse('supplierFacility', this.props.formData, {}),
			exchangeRate: nullSafeGetOrElse('formData.currencyExchangeRateLocationToSupplier', props, 1),
			currencyExchangeRateBuyerToLocation: nullSafeGetOrElse(
				'currencyExchangeRateBuyerToLocation',
				this.props.formData,
				1
			),
			currentNTE: nullSafeGetOrElse('formData.nte', props, 0),
			locationNTE: nullSafeGetOrElse(
				'formData.nteInLocationCurrency',
				props,
				nullSafeGetOrElse('formData.nte', props, 0) /
					nullSafeGetOrElse('currencyExchangeRateLocationToSupplier', this.props.formData, 1)
			),
			numPicturesRequired: nullSafeGetOrElse(
				'problemType.serviceRequestNumPicturesRequired',
				this.props.formData,
				0
			),
			currentApprovalHierarchy: {},
			editorRef: React.createRef(),
			isFinalApproval: false,
			invoiceDisallowsNTE: false,
			isPrivate: nullSafeGetOrElse('isPrivate', this.props.formData, false),
			isPrivateModalVisible: false,
			isPrivateLoading: false,
		};
	}

	isApproval = () => {
		const { isApprovalForm, currentUser, companyConfig } = this.props;
		const { hasApprovalHierarchy, workOrderApprovalHierarchy } = this.state;
		return (
			isApprovalForm &&
			(checkHasApprovalHierarchy({ hasApprovalHierarchy: hasApprovalHierarchy })
				? isInApprovalHierarchy(currentUser, workOrderApprovalHierarchy)
				: isUserAllowedToAccess(currentUser.userType)(
						PERMISSION_NAMES.CAN_APPROVE_WORK_ORDERS,
						companyConfig,
						currentUser.roles
				  ))
		);
	};
	getDefaultProblemTypeNTE(problemTypeId) {
		const { fetchWorkOrderAttributes } = this.props;

		fetchWorkOrderAttributes({ problemTypeId }).then((workOrderAttributes) => {
			this.setState({ workOrderAttributes });
			nullSafeGet('0.NTEAmount', workOrderAttributes) &&
				this.setState({
					workOrderAttributesNTE: workOrderAttributes[0].NTEAmount,
				});
		});
	}

	componentDidMount() {
		const {
			form,
			formData,
			fetchApprovalHeirarchy,
			currentUser,
			fetchExchangeRate,
			getQuotes,
			getInvoiceCounts,
			getApprovalHierarchy,
		} = this.props;
		const { locationNTE, supplier } = this.state;
		const isInternalTech = nullSafeGet('facility.status', currentUser) === 'private';

		getInvoiceCounts({
			workOrderId: formData.id,
			statuses: NTE_LOCKED_STATUSES,
		}).then((count) => {
			this.setState({ invoiceDisallowsNTE: count > 0 });
		});

		if (isInternalTech) {
			getApprovalHierarchy({ isCapex: formData.isCapex, isPM: formData.isPM }).then((result) => {
				this.setState({ currentApprovalHierarchy: result }, () =>
					this.configureNTEWarningMessage()
				);
			});
			this.initialCheckIsFinalApproval();
			fetchApprovalHeirarchy().then((data) => {
				const tiers = nullSafeGet('0.tierDetails', data);
				if (tiers && tiers.length > 0) {
					const userTier =
						_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) ||
						tiers[0];
					this.setState({
						approvalHeirarchy: { amount: userTier.amountUpto || 1000000000 },
					});
				}
			});
		}

		const problemTypeId = nullSafeGet('problemType.id', formData);
		problemTypeId && this.getDefaultProblemTypeNTE(problemTypeId);

		let photosInfo;
		if (formData.images) {
			photosInfo = formData.images.map((p, idx) => {
				const [imgFileId, imgFileName] = p.split('/');
				const thumbUri = getProtectedImageUriForSupplier(imgFileId, imgFileName, 100, 100);
				const fullUri = getProtectedImageUriForSupplier(imgFileId, imgFileName, 400, 400);
				return {
					uid: idx,
					size: 1,
					name: imgFileName,
					filename: imgFileName,
					url: fullUri,
					status: 'done',
					thumbUrl: thumbUri,
					response: { data: { fileName: imgFileName, fileId: imgFileId } },
					type: 'image/jpeg',
				};
			});
		} else {
			photosInfo = [];
		}

		this.setState({
			locationId: formData.locationId,
			problemTypeId: formData.problemTypeId,
			workOrderPriorityId: formData.woPriorityId,

			assetSelectionDisabled: formData.assetId || formData.locationId ? false : true,
			allPhotos: photosInfo,
			location: nullSafeGetOrElse('location', formData, {}),
		});

		getQuotes(
			{
				workOrderId: formData.id,
				supplierFacilityId: formData.supplierFacilityId,
			},
			'workOrderAssociatedQuotes'
		).then((proposals) => {
			if (proposals.length > 0) {
				this.setState({ hasQuote: true });
			} else {
				const supplierCurrency = getCurrency({ supplier });
				const workOrderCurrency = getCurrency({ workOrder: formData });
				if (supplierCurrency && workOrderCurrency && workOrderCurrency.id !== supplierCurrency.id) {
					//Should only be possible if Suppliers Currency has changed
					fetchExchangeRate(
						supplierCurrency.id,
						workOrderCurrency.id,
						currentUser.contactType
					).then((rate) =>
						this.setState(
							{
								exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
								currentNTE: locationNTE * nullSafeGetOrElse('conversionRate', rate, 1),
							},
							() => {
								form.setFieldsValue({
									nteInLocationCurrency: locationNTE,
								});
							}
						)
					);
				}
			}
		});
	}

	configureNTEWarningMessage = () => {
		const { currentUser } = this.props;
		const { currentApprovalHierarchy, nextApprovalHierarchy } = this.state;
		const tiers = nullSafeGet('tierDetails', nextApprovalHierarchy || currentApprovalHierarchy);
		if (tiers && tiers.length > 0) {
			const userTier =
				_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
			this.setState({
				userApprovalInfo: { amount: userTier.amountUpto || 1000000000 },
			});
		}
	};

	isWorkOrderSupplierPrivate = () => {
		const { supplier, supplierFacilityId } = this.state;
		return supplierFacilityId && nullSafeGetOrElse('status', supplier, 'private') === 'private';
	};

	getStatus = (supplierFacilityId, oldStatus) => {
		const { currentUser } = this.props;

		if (defensiveIsUserInternalSupplier(currentUser)) {
			let newStatus;
			if (
				PRE_SUPPLIER_ASSIGNMENT_STATUSES.includes(oldStatus) &&
				this.isWorkOrderSupplierPrivate()
			) {
				newStatus = WORK_ORDER_STATUSES.assignedToInternalTech;
			} else if (PRE_SUPPLIER_ASSIGNMENT_STATUSES.includes(oldStatus) && supplierFacilityId) {
				newStatus = WORK_ORDER_STATUSES.pendingConfirmationByServiceProvider;
			} else if (
				oldStatus === WORK_ORDER_STATUSES.supplierInitiatedPendingApproval &&
				supplierFacilityId
			) {
				newStatus = WORK_ORDER_STATUSES.confirmedByServiceProvider;
			} else if (!supplierFacilityId) {
				newStatus = WORK_ORDER_STATUSES.unassigned;
			} else {
				newStatus = oldStatus;
			}
			return newStatus;
		}
		return oldStatus;
	};

	getAdditionalInfo = () =>
		nullSafeGet('state.editorRef.current', this) &&
		(this.state.editorRef.current as any).getContent();

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	deleteCapExCategoryAssociation = () => {
		const { formData, deleteCapExAssociation } = this.props;
		return formData.capExCategoryAssociationId
			? deleteCapExAssociation(formData.capExCategoryAssociationId)
			: new Promise((resolve) => resolve(true));
	};

	updateCapExCategory = (values) => {
		const { companyConfig, currentUser, saveCapExAssociation } = this.props;
		if (
			getBuyerCompanySettingValue(ROLE_TYPES.SUPPLIER)(
				'capExConfig.acceptCapExCategory',
				companyConfig,
				currentUser
			)
		) {
			return values.isCapex === 'true'
				? saveCapExAssociation({
						workOrderId: values.id,
						...(nullSafeGet('capExCategoryInput.capExCategoryId', values) && {
							capExCategoryId: values.capExCategoryId,
						}),
						capExCategory: nullSafeGetOrElse('capExCategoryInput.capExCategory', values, ''),
				  })
				: this.deleteCapExCategoryAssociation();
		} else return new Promise((resolve) => resolve(true));
	};

	handleSubmit = (e) => {
		const {
			form,
			formData,
			history,
			redirectForwardUrl,
			onSuccess,
			updateWorkOrderForm,
			approveWorkOrderForm,
			currentUser,
		} = this.props;
		const { exchangeRate, supplier, location, currentNTE, hasQuote, isCapex } = this.state;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier });
		const workOrderCurrency = getCurrency({ workOrder: formData });

		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				const nte = this.isWorkOrderSupplierPrivate() ? undefined : currentNTE || 0;
				const nteInLocationCurrency = this.isWorkOrderSupplierPrivate()
					? undefined
					: parseFloat(values.nteInLocationCurrency) || 0;
				// put image data into proper format to persist
				const picturesInfo = values.images.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});
				let workOrder: any = {
					...formData,
					id: values.id,
					title: values.title,
					status: this.isApproval()
						? this.getStatus(values.supplierFacilityId, values.status)
						: values.status,
					isPrivate: values.isPrivate,
					areaId: values.areaId ? parseInt(values.areaId, 10) : undefined,
					problemTypeId: parseInt(values.problemTypeId, 10),
					woPriorityId: parseInt(values.workOrderPriorityId, 10),
					spendCategoryId: parseInt(values.spendCategoryId, 10),
					locationId: parseInt(values.locationId, 10),
					assetId: values.assetId ? parseInt(values.assetId, 10) : null,
					...(values.assetId && {
						isAssetDown: values.isAssetDown === 'true' ? true : false,
					}),
					isWarranty: values.isWarranty === 'true',
					images: picturesInfo,
					isCapex,
					dueDate: values.dueDate,
					nte: nte,
					currencyId: !hasQuote ? supplierCurrency.id : workOrderCurrency.id,
					nteInLocationCurrency: nteInLocationCurrency,
					locationCurrencyId: locationCurrency.id,
					currencyExchangeRateLocationToSupplier:
						locationCurrency.id === supplierCurrency.id ? 1 : exchangeRate,
					description: this.getAdditionalInfo(),
					buyerFacilityId: undefined,
					buyerCompanyId: values.buyerCompanyId,
					createdBy: values.createdBy,
					supplierFacilityId: values.supplierFacilityId,
					contractorDetails: values.contractorDetails,
					notes: values.notes,
					poNumber: values.poNumber,
					buyerAttachments: values.buyerAttachments,
					supplierAttachments: values.supplierAttachments,
					buyerProjectIds: values.buyerProjectIds,
					resolutionTypeId: values.resolutionType,
				};
				if (
					nullSafeGet('isSupplierInitiated', formData) &&
					isSupplierPayingCustomerAndAdmin(currentUser)
				) {
					workOrder.woNumber = values.woNumber;
				}

				const updateCapExCategoryPromise = this.updateCapExCategory(values);
				const updateOrApprovePromise = this.isApproval()
					? approveWorkOrderForm(workOrder)
					: updateWorkOrderForm(workOrder);

				Promise.all([updateCapExCategoryPromise, updateOrApprovePromise]).then((results) => {
					redirectForwardUrl && history.push(redirectForwardUrl);
					results && results[1] && onSuccess && onSuccess(results[1]);
				});
			}
		});
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			thumbUrl = getProtectedImageUriForSupplier(imgFileId, imgFileName, 100, 100);
			fullUrl = getProtectedImageUriForSupplier(imgFileId, imgFileName, 400, 400);
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: imgFileName,
				filename: imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image/jpeg',
			};
		}

		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleCancel = () => this.setState({ previewVisible: false });

	handleImageUpdate = (info) => {
		if (info.file.status === 'done') {
			this.setState({ allPhotos: info.fileList });
		} else if (info.file.status === undefined) {
			info.fileList = this.state.allPhotos;
		}
	};

	isAreaFilterAllowed = () => {
		const { companyConfig, currentUser } = this.props;
		return getBuyerCompanySettingValue(ROLE_TYPES.SUPPLIER)(
			'assetConfig.allowAreaAssociationWithAssets',
			companyConfig,
			currentUser,
			false
		);
	};

	handleLocationChange = (locationId) => {
		const { fetchLocation, fetchWorkOrderPriorities } = this.props;
		const { supplier } = this.state;
		fetchLocation(locationId).then((loc) => {
			this.setState(
				{
					locationId: locationId,
					buyerFacilityId: loc.buyerFacilityId,
					location: loc,
				},
				() => {
					new Promise((resolve, reject) => {
						resolve(this.checkBuyerToLocationCurrencyChange(loc));
					}).then(() => {
						this.checkCurrencyChange(loc, supplier);
					});
				}
			);
			fetchWorkOrderPriorities({ buyerCompanyId: loc.buyerCompanyId }).then((data) => {
				const { updateWOPriorityRecords } = this.props;
				return new Promise((resolve) => {
					const locationBuyerCompanyId = nullSafeGetOrElse(
						'state.location.buyerCompanyId',
						this,
						-1
					);
					const filteredData = data.find((_) => _.buyerCompanyId === locationBuyerCompanyId)
						? data.filter((_) => _.buyerCompanyId === locationBuyerCompanyId)
						: data.filter((_) => _.buyerCompanyId === -1);
					updateWOPriorityRecords(
						filteredData,
						filteredData.length,
						WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE
					);
					resolve(filteredData);
				});
			});
		});
	};

	handleAreaChange = (areaId) => {
		this.setState({ areaId: areaId });
	};

	getProblemTypeRecord = (problemTypeId) => {
		return new Promise((resolve, reject) => {
			const { problemTypes, fetchProblemType } = this.props;
			const records = getRecordsForTargetCollection(
				problemTypes,
				WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE
			);
			const problemType = records.find((_) => _.id === problemTypeId);
			problemType
				? resolve(problemType)
				: fetchProblemType(problemTypeId)
						.then((res) => resolve(res))
						.catch((err) => reject(err));
		});
	};
	handleWorkOrderPriorityChange = (woPriorityId) => {
		const { form } = this.props;
		this.confirmChange = () => {
			this.setState({ woPriorityId }, () => {
				this.updateDueDate();
			});
		};
		this.cancelChange = () => {
			form.setFieldsValue({ workOrderPriorityId: this.state.woPriorityId });
		};
		this.changeApprovalHierarchyParamCheck({ woPriorityId: woPriorityId });
	};
	handleProblemTypeChange = (problemTypeId) => {
		const { form } = this.props;
		this.confirmChange = () => {
			this.setState({ problemTypeId });
			new Promise((resolve, reject) => {
				resolve(this.getDefaultProblemTypeNTE(problemTypeId));
			}).then(() => {
				this.resetNTE();
			});
			this.getProblemTypeRecord(problemTypeId).then((problemType) => {
				this.setState({
					numPicturesRequired: nullSafeGetOrElse(
						'serviceRequestNumPicturesRequired',
						problemType,
						0
					),
				});
			});
		};
		this.cancelChange = () => {
			form.setFieldsValue({ problemTypeId: this.state.problemTypeId });
		};
		this.changeApprovalHierarchyParamCheck({ problemTypeId: problemTypeId });
	};

	fetchSupplierData = (
		searchText = '',
		targetCollectionName = WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		const { fetchSupplierFacilitiesInPrivateNetwork } = this.props;
		const { warranty, isFinalApproval } = this.state;
		return new Promise((resolve, reject) =>
			fetchSupplierFacilitiesInPrivateNetwork(
				{ name: searchText, offset: 0, limit: 100 },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			).then((data) => {
				const { addWarrantySupplier, fetchSupplierFacilitiesInPrivateNetwork, form, formData } =
					this.props;
				const warrantySupplierId = nullSafeGet('provider.supplierFacilityId', warranty);
				if (data && !data.some((supplier) => nullSafeGet('id', supplier) === warrantySupplierId)) {
					/*
						Removed because it is crashing the app
						addWarrantySupplier(
							warrantySupplierId,
							WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE
						);
					 */
				}
				const supplierFacilityId = form.getFieldValue('supplierFacilityId');
				if (this.isApproval() && isFinalApproval && !supplierFacilityId && data.length > 0) {
					form.setFieldsValue({ supplierFacilityId: nullSafeGet('0.id', data) });
				}
				resolve(data);
			})
		);
	};

	handleAssetChange = (assetId) => {
		const { fetchAsset } = this.props;
		if (assetId) {
			fetchAsset(assetId).then((asset) => {
				this.setState(
					{
						assetId,
						asset,
						warranty: nullSafeGet('warranties.0', asset),
					},
					() => {
						this.resetNTE();
						this.fetchSupplierData();
					}
				);
			});
		} else {
			this.setState({ assetId: assetId, asset: undefined, warranty: undefined });
		}
	};

	calculateDueDate = () => {
		const { workOrderPriorities, form } = this.props;
		const { woPriorityId } = this.state;
		const woPriority = getEntityById(woPriorityId, workOrderPriorities);
		const currentDueDate = form.getFieldValue('dueDate');
		return getDueDate(woPriority, currentDueDate);
	};

	updateDueDate = () => {
		const { form } = this.props;
		form.setFieldsValue({ dueDate: this.calculateDueDate() });
	};

	assetWarranty = () => {
		const { form } = this.props;
		const { asset, supplierFacilityId, currencyExchangeRateBuyerToLocation } = this.state;
		const isWarranty = form.getFieldValue('isWarranty') === 'true';
		const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
		const assetSupplierId = nullSafeGet('warranties.0.provider.supplierFacilityId', asset);
		const assetWarrantyNTE =
			nullSafeGet('warranties.0.NTEAmount', asset) * currencyExchangeRateBuyerToLocation;

		return (
			assetWarrantyStatus === 'Active' &&
			assetSupplierId === supplierFacilityId &&
			isWarranty &&
			assetWarrantyNTE
		);
	};

	checkBuyerToLocationCurrencyChange = (location) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrencyId = getCurrency({ location }).id;
		const buyerCurrencyId = getCurrency({ currentUser }).id;
		if (locationCurrencyId !== buyerCurrencyId) {
			fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then(
				(rate) => {
					this.setState({
						currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
					});
				}
			);
		} else {
			this.setState({ currencyExchangeRateBuyerToLocation: 1 });
		}
	};

	checkCurrencyChange = (location, supplierFacility) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier: supplierFacility });
		if (supplierCurrency && locationCurrency && locationCurrency.id !== supplierCurrency.id) {
			fetchExchangeRate(supplierCurrency.id, locationCurrency.id, currentUser.contactType).then(
				(rate) =>
					this.setState(
						{
							exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
						},
						() => {
							this.resetNTE();
						}
					)
			);
		} else {
			this.resetNTE();
		}
	};

	//When some field has changed (supplier/asset/problem type), check what NTE should be.
	resetNTE = () => {
		const { form } = this.props;
		const {
			exchangeRate,
			locationNTE,
			workOrderAttributesNTE,
			supplier,
			currencyExchangeRateBuyerToLocation,
		} = this.state;

		const assetWarrantyNTE = this.assetWarranty();
		const hasSupplier = supplier && supplier.id !== undefined;

		const newLocationNTE = getNewLocationNTE(
			hasSupplier,
			this.isWorkOrderSupplierPrivate(),
			assetWarrantyNTE,
			locationNTE,
			workOrderAttributesNTE,
			currencyExchangeRateBuyerToLocation
		);
		this.setState(
			{
				currentNTE:
					isValidNumber(newLocationNTE) && isValidNumber(exchangeRate)
						? newLocationNTE * exchangeRate
						: undefined,
				locationNTE: newLocationNTE,
			},
			() => {
				form.setFieldsValue({
					nteInLocationCurrency: nullSafeToFixed(newLocationNTE),
				});
			}
		);
	};

	handleSupplierFacilityChange = (supplierFacilityId) => {
		const { form, fetchSupplierFacility } = this.props;
		const { location } = this.state;
		this.updateDueDate();
		if (supplierFacilityId) {
			fetchSupplierFacility(supplierFacilityId).then((supplierFacility) => {
				this.setState(
					{
						supplier: supplierFacility,
						supplierFacilityId,
					},
					() => {
						this.checkCurrencyChange(location, supplierFacility);
					}
				);
			});
		} else {
			this.setState({ supplier: {}, locationNTE: undefined });
			form.setFieldsValue({ nteInLocationCurrency: undefined });
		}
	};

	checkIsFinalApproval = (workOrderApproval) => {
		this.setState({
			isFinalApproval: !!workOrderApproval.isAlreadyApprovedOrWillBeApprovedIfCurrentUserApproves,
		});
	};

	initialCheckIsFinalApproval = () => {
		const { willApprovalHierarchyChange, formData } = this.props;
		willApprovalHierarchyChange(nullSafeGet('id', formData), {}).then((result) => {
			this.checkIsFinalApproval(nullSafeGetOrElse('workOrderApprovalChanges', result, {}));
		});
	};

	toggleIsPrivate = () => {
		const { formData, currentUser, addSupplierSubscribers } = this.props;
		if (this.state.isPrivate) {
			this.setState({ isPrivateModalVisible: true });
		} else {
			const subscriberEmails = [
				...nullSafeGetOrElse('supplierSubscriberEmails', formData, []),
				...nullSafeGetOrElse('buyerSubscriberEmails', formData, []),
			];
			const isUserSubscribed = subscriberEmails.includes(currentUser.email);

			if (!isUserSubscribed) {
				this.setState({ isPrivateLoading: true });
				addSupplierSubscribers(
					{
						id: formData.id,
						addSupplierSubscriberEmails: [currentUser.email],
					},
					formData
				)
					.then(() => this.setState({ isPrivate: true }))
					.catch((err) => message.error('Failed to make the work order private, please try again.'))
					.finally(() => {
						this.setState({ isPrivateLoading: false });
					});
			} else {
				this.setState({ isPrivate: true });
			}
		}
	};

	confirmIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false, isPrivate: false });
	};

	cancelIsPrivateModal = () => {
		this.setState({ isPrivateModalVisible: false });
	};

	//param = {key: value}
	changeApprovalHierarchyParamCheck = (param) => {
		const { willApprovalHierarchyChange, formData, isApprovalForm, currentUser } = this.props;
		const isInternalTech = nullSafeGet('facility.status', currentUser) === 'private';
		const { woChanges } = this.state;
		const changes = { ...woChanges, ...param };

		this.setState({ buttonLoading: true, pendingParam: param });
		if (!isInternalTech) {
			this.changeApprovalHierarchyParamConfirm(param)();
			return;
		}
		willApprovalHierarchyChange(nullSafeGet('id', formData), changes).then((result) => {
			//CHECKS TO SEE IF THEY HAVE CHANGED FROM THE INITIAL record.approvalHierarchy
			const quoteHierarchyChanged =
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const quoteChanged =
				nullSafeGet('quoteApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('quoteApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const invoiceChanged =
				nullSafeGet('invoiceApprovalChanges.hasApprovedByUsers', result) &&
				nullSafeGetOrElse('invoiceApprovalChanges.changedHierarchy.length', result, 0) > 0;
			const workOrderHierarchyChanged =
				nullSafeGetOrElse('workOrderApprovalChanges.changedHierarchy.length', result, 0) > 0 &&
				isApprovalForm; //If the work order has changed from the initial formData.approvalHierarchy
			const hasWorkOrderApprovalHierarchy = nullSafeGetOrElse(
				'workOrderApprovalChanges.hasApprovalHierarchy',
				result,
				false
			);

			this.checkIsFinalApproval(nullSafeGetOrElse('workOrderApprovalChanges', result, {}));

			this.setState({
				nextApprovalHierarchy: quoteHierarchyChanged
					? nullSafeGet('quoteApprovalChanges.changedHierarchy.0', result)
					: undefined,
				nextWorkOrderApprovalHierarchy: workOrderHierarchyChanged
					? nullSafeGet('workOrderApprovalChanges.changedHierarchy.0', result)
					: nullSafeGet('approvalHierarchy', formData),
				nextHasApprovalHierarchy: hasWorkOrderApprovalHierarchy,
			});
			if (quoteChanged || invoiceChanged || workOrderHierarchyChanged) {
				this.setState({
					showApprovalHierarchyChangeModal: true,
					approvalHierarchyChanges: [
						...(quoteChanged ? ['quote'] : []),
						...(invoiceChanged ? ['invoice'] : []),
						...(workOrderHierarchyChanged ? ['work order'] : []), //doesn't matter if approvers are present or not
					],
				});
			} else {
				this.changeApprovalHierarchyParamConfirm(param)();
			}
		});
	};
	changeApprovalHierarchyParamConfirm = (param) => () => {
		const { woChanges } = this.state;
		this.confirmChange();
		this.setState({
			...param,
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			pendingParam: undefined,
			workOrderApprovalHierarchy: this.state.nextWorkOrderApprovalHierarchy,
			nextWorkOrderApprovalHierarchy: undefined,
			hasApprovalHierarchy: this.state.nextHasApprovalHierarchy,
			nextHasApprovalHierarchy: undefined,
			woChanges: { ...woChanges, ...param },
		});
	};
	changeApprovalHierarchyParamDismiss = () => {
		this.cancelChange();
		this.setState({
			showApprovalHierarchyChangeModal: false,
			buttonLoading: false,
			pendingParam: undefined,
			nextApprovalHierarchy: undefined,
			nextWorkOrderApprovalHierarchy: undefined,
			nextHasApprovalHierarchy: undefined,
		});
	};

	render() {
		const {
			updating,
			form,
			formData,
			locations,
			areas,
			problemTypes,
			workOrderPriorities,
			currentUser,
			fetchLocations,
			fetchMultipleLocations,
			fetchAreas,
			fetchMultipleAreas,
			fetchProblemTypes,
			fetchMultipleProblemTypes,
			fetchWorkOrderPriorities,
			fetchMultipleWorkOrderPriorities,
			supplierFacilities,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			projects,
			fetchProjects,
			fetchMultipleProjects,
			resolutionTypes,
			fetchMultipleResolutionTypes,
			fetchResolutionTypes,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const {
			previewVisible,
			previewImage,
			warranty,
			location,
			supplier,
			exchangeRate,
			currentNTE,
			locationNTE,
			currencyExchangeRateBuyerToLocation,
			hasQuote,
			isCapex,
			userApprovalInfo,
		} = this.state;
		const dateFormat = 'dddd, MMM D, YYYY, h:mm A';
		const submitLabel = this.isApproval() ? 'Approve work order' : 'Update work order';
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const isAdmin = currentUser.roles.some((role) => SUPPLIER_ADMIN_ONLY.has(role));
		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier });
		const workOrderCurrency = getCurrency({ workOrder: formData });
		const allowedToEditNTE =
			nullSafeGet('facility.internalTechConfig.allowedToApproveProposal', currentUser) ||
			isSupplierPayingCustomerAndAdmin(currentUser);
		const isInternalTech = nullSafeGet('facility.status', currentUser) === 'private';
		const managingWOBuyerCompany = isManagedBuyerCompanyIdWO(formData, currentUser);

		const resolutionsFetching = nullSafeGet('fetching', resolutionTypes);
		const hasResolutionTypes = resolutionsFetching
			? true
			: getObjectValues(nullSafeGetOrElse('records', resolutionTypes, {})).length > 0;
		getFieldDecorator('id', { initialValue: formData.id });
		getFieldDecorator('createdAt', { initialValue: formData.createdAt });
		getFieldDecorator('notes', { initialValue: formData.notes });
		getFieldDecorator('poNumber', { initialValue: formData.poNumber });
		getFieldDecorator('buyerFacilityId', {
			initialValue: formData.buyerFacilityId,
		});
		getFieldDecorator('buyerCompanyId', {
			initialValue:
				formData.buyerCompanyId ||
				nullSafeGet('facility.supplierCompany.privateBuyerCompanyId', currentUser),
		});
		getFieldDecorator('createdBy', {
			initialValue: formData.createdBy || nullSafeGet('email', currentUser),
		});
		getFieldDecorator('contractorDetails', {
			initialValue: formData.contractorDetails || {
				contractorContacts: [],
			},
		});

		getFieldDecorator('problemTypeId', {
			initialValue: this.state.problemTypeId,
		});
		getFieldDecorator('isCapex', {
			initialValue: formData.isCapex,
		});
		if (!isInternalTech) {
			getFieldDecorator('supplierFacilityId', {
				initialValue: formData.supplierFacilityId,
			});
			getFieldDecorator('nteInLocationCurrency', {
				initialValue: locationNTE,
			});
		}

		getFieldDecorator('buyerAttachments', { initialValue: formData.buyerAttachments || [] });
		getFieldDecorator('supplierAttachments', { initialValue: formData.supplierAttachments || [] });

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');
		const minPhotosCount = this.isApproval()
			? 0
			: nullSafeGetOrElse('state.numPicturesRequired', this, 0);

		const imageCountErrorMessage = `You need to upload at least ${minPhotosCount} photo${
			minPhotosCount > 1 ? 's' : ''
		}`;

		const areaFilterAllowed = this.isAreaFilterAllowed();

		const calculatedDueDate = formData.dueDate ? moment(formData.dueDate) : this.calculateDueDate();
		getFieldDecorator('dueDate', { initialValue: calculatedDueDate });

		return (
			<Form layout="vertical" onSubmit={this.handleSubmit} className="supplierForm">
				<Form.Item label="Title">
					{getFieldDecorator('title', {
						initialValue: formData.title,
						rules: [{ required: true, message: 'This field is required.' }],
					})(<Input style={{ maxWidth: 800 }} />)}
				</Form.Item>
				{nullSafeGet('isSupplierInitiated', formData) &&
				isSupplierPayingCustomerAndAdmin(currentUser) ? (
					<Form.Item label="Alias Work Order Number">
						{getFieldDecorator('woNumber', {
							initialValue: formData.woNumber,
						})(<Input style={{ maxWidth: 800 }} />)}
					</Form.Item>
				) : null}
				<Form.Item label="Incident Location">
					{getFieldDecorator('locationId', {
						initialValue: this.state.locationId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							stateSlice={locations}
							targetCollectionName={WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE}
							onChange={this.handleLocationChange}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleLocations(ids, targetCollectionName);
							}}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) => {
								fetchLocations(
									{ search: searchText || undefined },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								);
							}}
							renderRecord={(location) => (
								<Select.Option key={location.id} value={location.id}>
									<div>
										{nullSafeGet('buyerCompany.name', location)} - {location.name}
									</div>
									<div style={{ color: 'rgba(0,0,0,0.45)' }}>
										{nullSafeGet('buyerFacility.primaryAddress.streetAddress1', location)},{' '}
										{nullSafeGet('buyerFacility.primaryAddress.city', location)}{' '}
										{nullSafeGet('buyerFacility.primaryAddress.region', location)}
									</div>
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item
					label="Area"
					help={
						locations.fetching ||
						areas.fetching ||
						nullSafeGetOrElse('recordsIds.length', areas[WORK_ORDER_FORM_AREAS_AUTOCOMPLETE], 0) > 0
							? null
							: 'No areas are associated with this location'
					}
				>
					{getFieldDecorator('areaId', {
						initialValue: formData.areaId,
					})(
						<ProblemTypeTreeSelect
							targetCollectionName={WORK_ORDER_FORM_AREAS_AUTOCOMPLETE}
							stateSlice={areas}
							allowClear
							fetchMultiple={fetchMultipleAreas}
							fetchData={fetchAreas}
							renderRecord={(area) => (
								<Select.Option key={area.id} value={area.id}>
									{area.name}
								</Select.Option>
							)}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								brandId: nullSafeGet('location.brandId', this.state),
								problemTypeId: nullSafeGet('problemTypeId', this.state),
							}}
						/>
					)}
				</Form.Item>
				<Form.Item required={true} label="Problem Type">
					{getFieldDecorator('problemTypeId', {
						initialValue: formData.problemTypeId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<ProblemTypeTreeSelect
							mode="default"
							stateSlice={problemTypes}
							targetCollectionName={WORK_ORDER_FORM_PROBLEM_TYPES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleProblemTypes(ids, targetCollectionName);
							}}
							onChange={this.handleProblemTypeChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							) =>
								fetchProblemTypes(
									{ name: searchText || undefined },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								)
							}
							additionalFilters={{
								locationId: nullSafeGet('locationId', this.state),
								brandId: nullSafeGet('location.brandId', this.state),
							}}
							sortBy={{ sort_by: 'name', order: 'ascend' }}
						/>
					)}
				</Form.Item>
				<Form.Item label="Affected Asset">
					{getFieldDecorator('assetId', {
						initialValue: formData.assetId,
					})(
						<AssetWorkOrderSelect
							onChange={this.handleAssetChange}
							additionalFilters={{
								locationId: nullSafeGetOrElse('locationId', this.state, formData.locationId),
								problemTypeId: nullSafeGetOrElse(
									'problemTypeId',
									this.state,
									formData.problemTypeId
								),
								...(areaFilterAllowed &&
									nullSafeGetOrElse('areaId', this.state, formData.areaId) && {
										areaIdOrNull: nullSafeGetOrElse('areaId', this.state, formData.areaId),
									}),
							}}
						/>
					)}
				</Form.Item>
				{getFieldValue('assetId') && (
					<Form.Item label="Is the asset functioning?">
						{form.getFieldDecorator('isAssetDown', {
							initialValue: formData.isAssetDown ? 'true' : 'false',
						})(
							<OWRadioGroup
								valueAccessor={(item) => item.value}
								renderRecord={(item) => item.label}
								items={[
									{
										label: 'Yes',
										value: 'false',
									},
									{
										label: 'No',
										value: 'true',
									},
								]}
							/>
						)}
					</Form.Item>
				)}
				<WOIsWarrantyFormField form={form} formData={formData} />
				<Form.Item label="Additional Info">
					{getFieldDecorator('additionalInfo', {
						initialValue: formData.description,
					})(
						<OWRichTextEditor
							initialEditorState={formData.description}
							editorRef={this.state.editorRef}
						/>
					)}
				</Form.Item>
				<Form.Item label="Photos">
					{getFieldDecorator(`images`, {
						valuePropName: 'fileList',
						getValueFromEvent: normFile,
						initialValue: this.state.allPhotos,
						rules: getImageCountErrorRules(minPhotosCount, imageCountErrorMessage),
					})(
						<OWUpload
							accept="image/*"
							name="file"
							listType="picture-card"
							className="workorder-image-uploader"
							multiple={true}
							headers={uploadHeaders}
							onPreview={this.handlePreview}
							action={`${BACKEND_URI}/api/v1/supplier/file/upload`}
							beforeUpload={imageUploadValidation}
							onChange={this.handleImageUpdate}
						>
							<div style={{ display: 'inline' }}>
								<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
								<div className="ant-upload-text">Upload</div>
							</div>
							<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
								<img alt="example" style={{ width: '100%' }} src={previewImage} />
							</Modal>
						</OWUpload>
					)}
				</Form.Item>
				{isInternalTech || managingWOBuyerCompany ? (
					isInternalTeam(nullSafeGet('supplier', this.state)) ? null : (
						<div className={'flex flex-row'}>
							<Form.Item
								label="NTE"
								validateStatus={userApprovalInfo.status}
								help={
									userApprovalInfo.status ? (
										<div
											style={{ width: 1000 }}
											className={'absolute flex flex-row flex-nowrap'}
										>{`This NTE change bypasses the requirement of a quote. Based on approval hierarchy, you can set NTE upto ${locationCurrency.format(
											userApprovalInfo.amount * currencyExchangeRateBuyerToLocation
										)}`}</div>
									) : !allowedToEditNTE ? (
										<div
											style={{ width: 1000 }}
											className={'absolute flex flex-row flex-nowrap'}
										>{`You are not allowed to update the NTE or approve quotes.`}</div>
									) : this.state.invoiceDisallowsNTE ? (
										<div style={{ width: 1000 }} className={'absolute flex flex-row flex-nowrap'}>
											{'The NTE cannot be changed while an invoice exists and is not disputed.'}
										</div>
									) : (
										''
									)
								}
								extra={
									nullSafeGet('supplier.status', this.state) === 'private' ? (
										<div className="mt-2 text-xs text-gray-500">
											NTE cannot be set for an internal team
										</div>
									) : null
								}
							>
								{getFieldDecorator('nteInLocationCurrency', {
									initialValue: locationNTE,
									validateTrigger: 'onChange',
									rules: [
										{
											validator: (rule, value, callback) => {
												if (
													userApprovalInfo.amount &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation >
														parseFloat(userApprovalInfo.amount) &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation !== formData.nte
												) {
													this.setState({
														userApprovalInfo: {
															...userApprovalInfo,
															status: isAdmin ? 'warning' : 'error',
														},
													});
													callback(isAdmin ? undefined : '');
												} else {
													this.setState({
														userApprovalInfo: {
															...userApprovalInfo,
															status: null,
														},
													});
													callback();
												}
											},
										},
									],
								})(
									<InputNumber
										style={{ width: 200 }}
										disabled={
											!allowedToEditNTE ||
											this.isWorkOrderSupplierPrivate() ||
											this.state.invoiceDisallowsNTE
										}
										addonAfter={locationCurrency.id}
										onChange={(value: any) =>
											this.setState({
												locationNTE: value,
												currentNTE: value * exchangeRate,
											})
										}
									/>
								)}
							</Form.Item>
							{supplierCurrency &&
							locationCurrency &&
							supplierCurrency.id !== locationCurrency.id &&
							!this.isWorkOrderSupplierPrivate() ? (
								<div className="flex flex-row" style={{ marginTop: 30 }}>
									<i
										className="icons8-font icons8-data-transfer"
										style={{ fontSize: 24, marginTop: 2, marginRight: 26 }}
									/>
									<InputNumber
										style={{ width: 200, height: 38 }}
										disabled={true}
										value={nullSafeToFixed(currentNTE)}
										addonAfter={hasQuote ? workOrderCurrency.id : supplierCurrency.id}
									/>
								</div>
							) : null}
						</div>
					)
				) : null}
				{isInternalTech ? (
					<Form.Item label="Expense Type">
						{getFieldDecorator('isCapex', {
							initialValue: formData.isCapex ? 'true' : 'false',
						})(
							<Row>
								<Spin spinning={this.state.buttonLoading}>
									<Radio.Group value={isCapex} style={{ display: 'flex' }}>
										{isCapex === false ? (
											<Radio.Button style={{ flexWrap: 'nowrap' }} value={false} onClick={() => {}}>
												R&M
											</Radio.Button>
										) : (
											<Radio.Button
												style={{ flexWrap: 'nowrap' }}
												value={false}
												onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: false })}
											>
												R&M
											</Radio.Button>
										)}
										{isCapex === true ? (
											<Radio.Button style={{ flexWrap: 'nowrap' }} value={true} onClick={() => {}}>
												CapEx
											</Radio.Button>
										) : (
											<Radio.Button
												style={{ flexWrap: 'nowrap' }}
												value={true}
												onClick={() => this.changeApprovalHierarchyParamCheck({ isCapex: true })}
											>
												CapEx
											</Radio.Button>
										)}
									</Radio.Group>
								</Spin>
								<Popover
									content={
										<div>
											<Row>
												<span style={{ fontSize: '20px' }}>Repair and Maintenance (R&M)</span>
											</Row>
											<Row>
												<span>Costs associated with repair and maintenance of existing assets</span>
											</Row>
											<Row style={{ height: '20px' }}></Row>
											<Row>
												<span style={{ fontSize: '20px' }}>Capital Expenditures (CapEx)</span>
											</Row>
											<Row>
												<span>
													Costs associated with buying new assets or upgrading existing assets
												</span>
											</Row>
										</div>
									}
								>
									<InfoCircleOutlined
										style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }}
									/>
								</Popover>
							</Row>
						)}
					</Form.Item>
				) : null}
				<CapExCategoryFormField
					isCapex={isCapex}
					getFieldDecorator={getFieldDecorator}
					formData={formData}
				/>
				<WorkOrderIsPrivateFormItem
					form={form}
					currentUser={currentUser}
					workOrder={formData}
					isPrivate={this.state.isPrivate}
					isPrivateModalVisible={this.state.isPrivateModalVisible}
					isPrivateLoading={this.state.isPrivateLoading}
					toggleIsPrivate={this.toggleIsPrivate}
					confirmIsPrivateModal={this.confirmIsPrivateModal}
					cancelIsPrivateModal={this.cancelIsPrivateModal}
				/>
				<Form.Item label="Priority">
					{getFieldDecorator('workOrderPriorityId', {
						initialValue: formData.woPriorityId,
						rules: [{ required: true, message: 'This field is required.' }],
					})(
						<OWAsyncSelect
							stateSlice={workOrderPriorities}
							targetCollectionName={WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE}
							fetchMultiple={(ids, targetCollectionName) => {
								fetchMultipleWorkOrderPriorities(ids, targetCollectionName);
							}}
							onChange={this.handleWorkOrderPriorityChange}
							fetchData={(
								searchText,
								targetCollectionName,
								pagination,
								sorting = {
									sort_by: 'expectedResolutionInSeconds',
									order: 'descend',
								},
								filters,
								addToTargetCollection
							) => {
								fetchWorkOrderPriorities(
									{ name: searchText },
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								).then((data) => {
									const { updateWOPriorityRecords } = this.props;
									return new Promise((resolve) => {
										const locationBuyerCompanyId = nullSafeGetOrElse(
											'state.location.buyerCompanyId',
											this,
											-1
										);
										const filteredData = data.find(
											(_) => _.buyerCompanyId === locationBuyerCompanyId
										)
											? data.filter((_) => _.buyerCompanyId === locationBuyerCompanyId)
											: data.filter((_) => _.buyerCompanyId === -1);
										updateWOPriorityRecords(
											filteredData,
											filteredData.length,
											targetCollectionName,
											{ ...pagination, total: filteredData.length },
											sorting,
											filters
										);
										resolve(filteredData);
									});
								});
							}}
							renderRecord={(workOrderPriority) => (
								<Select.Option key={workOrderPriority.id} value={workOrderPriority.id}>
									{workOrderPriority.name}
								</Select.Option>
							)}
						/>
					)}
				</Form.Item>
				<ApprovalHierarchyChangeModal
					visible={this.state.showApprovalHierarchyChangeModal}
					onOk={this.changeApprovalHierarchyParamConfirm}
					param={this.state.pendingParam}
					onCancel={this.changeApprovalHierarchyParamDismiss}
					approvalHierarchyChanges={this.state.approvalHierarchyChanges}
				/>
				{isInternalTech ? (
					<Form.Item
						required={true}
						label="Supplier"
						help={
							isInternalTech ? (
								<div className="flex flex-row items-baseline">
									<TransferWorkOrder
										workOrder={formData}
										buttonProps={{ type: 'link', children: 'Click Here' }}
										additionalOnChangeMethod={(wo) =>
											this.handleSupplierFacilityChange(nullSafeGet('supplierFacilityId', wo))
										}
									/>
									<div>to transfer this work order to a different supplier</div>
								</div>
							) : null
						}
					>
						{getFieldDecorator('supplierFacilityId', {
							initialValue: formData.supplierFacilityId,
						})(
							<SupplierSelectionWorkOrderSelect
								disabled={true}
								allowClear={false}
								stateSlice={supplierFacilities}
								targetCollectionName={
									WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE
								}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
								}}
								warrantySupplierId={nullSafeGet('provider.supplierFacilityId', warranty)}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) =>
									this.fetchSupplierData(
										searchText,
										targetCollectionName,
										pagination,
										(sorting = {}),
										filters,
										addToTargetCollection
									)
								}
								onChange={this.handleSupplierFacilityChange}
								additionalFilters={{
									problemTypeId: this.state.problemTypeId,
									locationId: this.state.locationId,
								}}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
							/>
						)}
					</Form.Item>
				) : null}
				{hasResolutionTypes ? (
					<Form.Item label="Resolution Type">
						{getFieldDecorator('resolutionType', {
							initialValue: formData.resolutionTypeId,
						})(
							<OWAsyncSelect
								style={{ maxWidth: 800 }}
								stateSlice={resolutionTypes}
								targetCollectionName={'RESOLUTION_TYPES_AUTOCOMPLETE'}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleResolutionTypes(ids, targetCollectionName);
								}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchResolutionTypes(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(resolutionType) => (
									<Select.Option key={resolutionType.id} value={resolutionType.id}>
										{resolutionType.resolutionCode ? `${resolutionType.resolutionCode} - ` : null}
										{resolutionType.resolutionType}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
								allowClear
							/>
						)}
					</Form.Item>
				) : null}
				<Form.Item label="Due date">
					{getFieldDecorator('dueDate', {
						rules: [{ required: true, message: 'This field is required.' }],
					})(<DatePicker style={{ width: 300 }} format={dateFormat} showTime={true} />)}
				</Form.Item>
				{isInternalTech ? (
					<Form.Item label="Project">
						{getFieldDecorator('buyerProjectIds', {
							initialValue: formData.buyerProjectIds,
						})(
							<OWAsyncSelect
								style={{ maxWidth: 800 }}
								mode={'multiple'}
								stateSlice={projects}
								targetCollectionName={WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleProjects(ids, targetCollectionName);
								}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchProjects(
										{ search: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(project) => (
									<Select.Option key={project.id} value={project.id}>
										{project.title}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				) : null}
				{getFieldDecorator('status', {
					initialValue: formData.status,
				})}
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={updating || isImageUploading}
						className="contactForm__button"
					>
						{submitLabel}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	formData: ownProps.formData,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	locations: state.locations,
	areas: state.areas,
	assets: state.assets,
	problemTypes: state.problem_types,
	spendCategories: state.spend_categories,
	workOrderPriorities: state.work_order_priorities,
	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
	projects: state.projects,
	resolutionTypes: state.resolution_types,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForSupplier.read(
				{ ...params, no_pagination: true, includeBuyerLocationsForPayingSupplier: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
		dispatch(resolutionTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchResolutionTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			resolutionTypesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleAssets: (ids, targetCollectionName) =>
		dispatch(assetsRestCrudThunksForSupplier.readLite({ ids }, targetCollectionName)),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchProblemType: (id) => dispatch(problemTypesRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleProblemTypes: (ids, targetCollectionName) =>
		dispatch(problemTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesHeirarchicalForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSpendCategory: (id) => dispatch(spendCategoriesRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchApprovalHeirarchy: (id) =>
		dispatch(getBuyerCompanyApprovalTiers(ROLE_TYPES.SUPPLIER, null)()),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForSupplier.read(params)),
	fetchWorkOrderPriority: (id) =>
		dispatch(workOrderPrioritiesRestCrudThunksForSupplier.readOne(id)),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderPriorities: (params, targetCollectionName, pagination, sorting, filters) =>
		dispatch(
			workOrderPrioritiesWithoutPMRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForSupplier.readOne(id)),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForSupplier(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	updateWorkOrdersFilters: (filters, targetCollection) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	updateWorkOrderForm: (workOrder) =>
		dispatch(workOrdersRestCrudThunksForSupplier.update(workOrder)),
	approveWorkOrderForm: (workOrder) => dispatch(approveWorkOrderForSupplier(workOrder)),
	addWarrantySupplier: (supplierId, targetCollectionName) =>
		dispatch(addWarrantySupplierToStoreState(supplierId, targetCollectionName)),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	getQuotes: (params, targetCollectionName) =>
		dispatch(proposalsRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchMultipleProjects: (ids, targetCollectionName) =>
		dispatch(projectsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	fetchProjects: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			projectsRestCrudThunksForSupplier.readLite(
				{ ...params, no_pagination: true },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	willApprovalHierarchyChange: (workOrderId, params) =>
		dispatch(hasApprovalHierarchyChanged('supplier', workOrderId, params)),
	getInvoiceCounts: (params) =>
		dispatch(invoicesRestCrudThunksForSupplier.countBy(params, 'invoiceCount')),
	addSupplierSubscribers: (obj, workOrder) =>
		dispatch(addSupplierSubscribersForSuppliers(obj)(workOrder)),
	getApprovalHierarchy: (params) =>
		dispatch(getProposalApprovalHierarchiesByAttributes('supplier', params)),
	updateWOPriorityRecords: (
		records,
		count,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			WORK_ORDER_PRIORITIES_CRUD_ACTION_CREATORS.fetchSuccess(
				records,
				count,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	saveCapExAssociation: (entity) =>
		dispatch(capexAssociationRestCrudThunksForSupplier.create(entity)),
	deleteCapExAssociation: (id) => dispatch(deleteCapexCategoryAssociation(ROLE_TYPES.SUPPLIER)(id)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			fetchAreasWithHeirarchy(ROLE_TYPES.SUPPLIER)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
});

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<WorkOrderFormProps>()(SupplierWorkOrderEditForm))
);
